/*********************************************************************************

Please Use Ghost-Button and pass color as a prop, Don't use black-ghost-button

**********************************************************************************/
import React from 'react';
import { Container } from './black-ghost-button-styles';
var GhostButton = function (_a) {
    var handleClick = _a.onClick, children = _a.children, href = _a.href, ref = _a.ref, padding = _a.padding, borderWidth = _a.borderWidth, borderRadius = _a.borderRadius, hoverEffect = _a.hoverEffect, width = _a.width;
    return (React.createElement(Container, { href: href, onClick: handleClick, ref: ref, padding: padding, borderWidth: borderWidth, borderRadius: borderRadius, hoverEffect: hoverEffect, width: width }, children));
};
export default GhostButton;
